(function() {
  'use strict';

  // デバッグモード（コンソールに詳細ログを出力）
  const DEBUG_MODE = false;

  function debugLog(message, data) {
    if (DEBUG_MODE) {
      if (data) {
        console.log('[Seller Profile Link Debug]', message, data);
      } else {
        console.log('[Seller Profile Link Debug]', message);
      }
    }
  }

  // 成功判定関数：Seller要素が見つかったかチェック
  function hasSellerElements() {
    const hasSeller = document.querySelector('[data-seller-processed="true"]');
    return hasSeller !== null;
  }

  // Seller Profile Linkが正常に表示されているか確認
  function checkSellerProfileLink() {
    let foundCount = 0;
    let processedCount = 0;

    // Webkul MultiVendor MarketplaceのSeller Profile Linkブロックを探す
    // セレクターのパターン:
    // - data-block-id属性に"seller-profile-link"を含む要素
    // - wk-sellerで始まるクラス名を持つ要素
    // - "販売元"というテキストを含む要素

    // 方法1: data-block-id属性で検索
    const sellerBlocks = document.querySelectorAll('[data-block-id*="seller-profile-link"]');
    debugLog('data-block-id属性で検索:', sellerBlocks.length + '個のブロックが見つかりました');

    sellerBlocks.forEach(block => {
      foundCount++;
      if (block.hasAttribute('data-seller-processed')) {
        return;
      }

      debugLog('Seller Profile Linkブロックを検出:', block);

      // ブロックが空でないか、または非表示でないかチェック
      const hasContent = block.textContent.trim().length > 0;
      const isVisible = block.offsetParent !== null;

      debugLog('  コンテンツあり:', hasContent);
      debugLog('  表示状態:', isVisible);

      // 処理済みマークを付ける
      block.setAttribute('data-seller-processed', 'true');
      processedCount++;
    });

    // 方法2: クラス名で検索（wk-seller, wk_seller等）
    const sellerElements = document.querySelectorAll('[class*="wk-seller"], [class*="wk_seller"], [id*="wk-seller"], [id*="wk_seller"]');
    debugLog('wk-seller*クラス/IDで検索:', sellerElements.length + '個の要素が見つかりました');

    sellerElements.forEach(element => {
      if (element.hasAttribute('data-seller-processed')) {
        return;
      }

      foundCount++;
      debugLog('Seller関連要素を検出:', element);

      const hasContent = element.textContent.trim().length > 0;
      const isVisible = element.offsetParent !== null;

      debugLog('  コンテンツあり:', hasContent);
      debugLog('  表示状態:', isVisible);

      element.setAttribute('data-seller-processed', 'true');
      processedCount++;
    });

    // 方法3: 「販売元」というテキストを含む要素を探す
    const allElements = document.querySelectorAll('.product-page__main *');
    allElements.forEach(element => {
      const text = element.textContent.trim();
      if (text.includes('販売元') && !element.hasAttribute('data-seller-text-processed')) {
        debugLog('「販売元」テキストを含む要素:', element);
        element.setAttribute('data-seller-text-processed', 'true');
        foundCount++;
      }
    });

    if (foundCount > 0) {
      debugLog('Seller Profile Link関連要素:', foundCount + '個検出、' + processedCount + '個処理');
    }

    return foundCount;
  }

  // 商品ページ関連の要素を監視・処理
  function processProductPage() {
    debugLog('▶ processProductPage 実行開始');
    const sellerCount = checkSellerProfileLink();
    debugLog('▶ processProductPage 実行完了: ' + sellerCount + '個のSeller要素を確認');
  }

  // 初回実行
  debugLog('=== 商品ページ監視スクリプト起動 ===');
  debugLog('document.readyState:', document.readyState);

  if (document.readyState === 'loading') {
    debugLog('DOMContentLoadedイベントを待機中...');
    document.addEventListener('DOMContentLoaded', function() {
      debugLog('DOMContentLoaded発火');
      processProductPage();
      if (hasSellerElements()) {
        debugLog('✅ DOMContentLoaded: Seller要素検出成功');
      }
    });
  } else {
    debugLog('既にDOMロード済み、即座に実行');
    processProductPage();
    if (hasSellerElements()) {
      debugLog('✅ 初回実行: Seller要素検出成功');
    }
  }

  // 複数回の遅延実行（アプリのDOM生成を待つ）
  debugLog('遅延実行をスケジュール: 300ms, 600ms, 1000ms, 1500ms, 2000ms, 3000ms, 5000ms');
  setTimeout(function() {
    debugLog('--- 300ms経過 ---');
    processProductPage();
  }, 300);
  setTimeout(function() {
    debugLog('--- 600ms経過 ---');
    processProductPage();
  }, 600);
  setTimeout(function() {
    debugLog('--- 1000ms経過 ---');
    processProductPage();
  }, 1000);
  setTimeout(function() {
    debugLog('--- 1500ms経過 ---');
    processProductPage();
  }, 1500);
  setTimeout(function() {
    debugLog('--- 2000ms経過 ---');
    processProductPage();
  }, 2000);
  setTimeout(function() {
    debugLog('--- 3000ms経過 ---');
    processProductPage();
  }, 3000);
  setTimeout(function() {
    debugLog('--- 5000ms経過 ---');
    processProductPage();
  }, 5000);

  // DOM変更を監視（デバウンス処理を追加）
  let debounceTimer;
  let mutationCount = 0;
  const observer = new MutationObserver(function(mutations) {
    mutationCount++;
    debugLog(`MutationObserver発火 (${mutationCount}回目):`, mutations.length + '個の変更');
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      debugLog('MutationObserver: デバウンス後に実行');
      processProductPage();

      // 成功したら監視を停止
      if (hasSellerElements()) {
        debugLog('✅ MutationObserver: Seller要素検出成功、監視を終了');
        observer.disconnect();
        clearInterval(intervalId);
      }
    }, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  debugLog('MutationObserverセットアップ完了');

  // 定期的なチェック（念のため、最初の10秒間）
  let checkCount = 0;
  debugLog('定期チェック開始: 500msごとに10秒間（20回）');
  const intervalId = setInterval(function() {
    checkCount++;
    debugLog(`--- 定期チェック ${checkCount}/20回目 ---`);
    processProductPage();

    // 成功したら監視を停止
    if (hasSellerElements()) {
      debugLog('✅ 定期チェック: Seller要素検出成功、監視を終了');
      clearInterval(intervalId);
      observer.disconnect();
      return;
    }

    if (checkCount >= 20) { // 10秒間（500ms x 20回）
      clearInterval(intervalId);
      observer.disconnect();
      debugLog('⏱️ Seller Profile Link監視タイムアウト（10秒経過）');
    }
  }, 500);
})();
